@if (!isDealer) {
  <div class="d-flex">
    @if (isCreateUpdateRemoveAccess) {
      <div>
        <button class="btn btn-primary " data-bs-toggle="modal" data-bs-target="#uploadCSVModal">Upload
        </button>
      </div>
    }
    @if (isCreateUpdateRemoveAccess) {
      <div class="pl-3">
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createRebateModal">
          Create
        </button>
      </div>
    }
    @if (isCreateUpdateRemoveAccess) {
      <div class="pl-3 btn-group">
        <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true">
          ZipUpload
        </button>
        <ul class="dropdown-menu">
          <li><button class="dropdown-item" type="button" (click)="checkZipUploadStatus()">Check status</button></li>
          <li><button class="dropdown-item" type="button" data-bs-toggle="modal"
          data-bs-target="#uploadZipRebateModal">Upload</button></li>
        </ul>
      </div>
    }
    <div class="ml-auto pl-3">
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Shop Or Company Name" [ngbTypeahead]="searchList"
          [(ngModel)]="searchName">
        <div class="input-group-append">
          <button class="btn btn-primary" type="button" (click)="searchRebatesListByName(0)" [disabled]="!searchName">
            <i class="fa-solid fa-magnifying-glass"></i>
          </button>
          <button class="btn btn-danger" type="button" (click)="clearRebatesListByName()" [disabled]="!searchName">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
}

<div class="table-responsive mt-2">
  <table class="table">
    <thead>
      <tr>
        <th>SrNo</th>
        @if (!isDealer) {
          <th>Name</th>
        }
        <th>Effective Date</th>
        <th>Description</th>
        <th>File Name</th>
        @if (isCreateUpdateRemoveAccess) {
          <th></th>
        }
      </tr>
    </thead>
    <tbody class="table-sm">
      @for (data of rebateList | paginate
        : {
        itemsPerPage: pageSize,
        currentPage: page + 1,
        totalItems: allTotal
        }; track data) {
        <tr>
          <td>{{data.srNo}}</td>
          @if (!isDealer) {
            <td>{{data.name}}</td>
          }
          <td>{{data.effectiveDate | dateFormat}}</td>
          <td>{{data.description}}</td>
          <td><button type="button" class="btn btn-link" (click)="openPDF(data)">{{data.fileName}}</button></td>
          @if (isCreateUpdateRemoveAccess) {
            <td>
              <div style="text-align: right">
                <!-- <button type="button" class="btn btn-primary" (click)="openUpdateModel(data)">Update</button>
                <button type="button" class="btn btn-danger ml-3" (click)="removeRebate(data.name)">
                  <span *ngIf="isUploading" class="spinner-border spinner-border-sm" role="status"
                  aria-hidden="true"></span>
                  <span *ngIf="!isUploading">Remove</span>
                </button> -->
                <button type="button" class="btn btn-primary btn-sm ms-auto" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <span><i class="fa-regular fa-pen-to-square"></i></span>
                  <span class="mx-1 fw-normal fst-italic">Edit</span>
                </button>
                <ul class="dropdown-menu">
                  <li><button class="dropdown-item" type="button" (click)="setData(data)" data-bs-toggle="modal"
                  data-bs-target="#updateFileModal">Update File</button></li>
                  <li><button class="dropdown-item" type="button" (click)="openUpdateModel(data)">Update Info</button></li>
                  <li>
                    <hr class="dropdown-divider">
                  </li>
                  <li><button class="dropdown-item" type="button" (click)="removeRebate(data.name)">Remove</button></li>
                </ul>
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>

<div style="text-align: center">
  <pagination-controls [maxSize]="20" previousLabel="Prev" nextLabel="Next" [responsive]="true"
  (pageChange)="handlePageChange($event)"></pagination-controls>
</div>
@if (loading) {
  <div class="loading d-flex justify-content-center">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
}

<!-- Create Rebate Model -->
<div class="modal" id="createRebateModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Create Rebate</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="createRebateForm">
          <div class="mb-3">
            <label class="form-label">Shop Or Company Name</label>
            <input type="text" class="form-control" [ngbTypeahead]="searchList" formControlName="dealerLoginName">
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <input type="text" class="form-control" formControlName="description">
          </div>
          <div class="mb-3">
            <label class="form-label">Effective Date (DD/MM/YYYY)</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="effectiveDate" placeholder="DD/MM/YYYY"
                ngbDatepicker #d="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">File (jpg only)</label>
            <input type="file" class="form-control" formControlName="file" accept=".jpg"
              (change)="onFileSelected($event)">
          </div>
        </form>
        @if (isError) {
          <div>
            <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="createRebate()" [disabled]="!createRebateForm.valid">
          @if (isUploading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
            <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Update Rebate Model -->
<div class="modal" tabindex="-1" [ngStyle]="{ display: displayStyle }" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Rebate</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="updateRebateForm">
          <div class="mb-3">
            <label class="form-label">Effective Date (DD/MM/YYYY)</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="effectiveDate" placeholder="DD/MM/YYYY"
                ngbDatepicker #dupdate="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="dupdate.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <input type="text" class="form-control" formControlName="description">
          </div>
        </form>
        @if (isError) {
          <div>
            <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModel()">Close</button>
        <button type="button" class="btn btn-primary" (click)="updateRebate()" [disabled]="!updateRebateForm.valid">
          @if (isUploading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
            <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Upload CSV Model -->
<div class="modal" id="uploadCSVModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Upload Rebate File</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="uploadRebateForm">
          <div class="mb-3">
            <label class="form-label">Shop Or Company Name</label>
            <input type="text" class="form-control" [ngbTypeahead]="searchList" formControlName="dealerLoginName">
          </div>
          <div class="mb-3">
            <label class="form-label">Effective Date (DD/MM/YYYY)</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="effectiveDate" placeholder="DD/MM/YYYY"
                ngbDatepicker #dZupload="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="dZupload.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Select File (File Name_Description)</label>
            <input type="file" class="file-input form-control" formControlName="file" accept=".jpg"
              (change)="onFileSelectedMulti($event)" multiple>
          </div>
        </form>
        @if (isUploadError) {
          <div class="mb-3">
            <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="uploadFile()">
          @if (isUploading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
            <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Upload Zip Model -->
<div class="modal" id="uploadZipRebateModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Upload Zip Rebate File</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="uploadZipRebateForm">
          <div class="mb-3">
            <label class="form-label">Effective Date (DD/MM/YYYY)</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="effectiveDate" placeholder="DD/MM/YYYY"
                ngbDatepicker #dupload="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="dupload.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Select Zip File (FileName_Description_UPGDealerID)</label>
            <input type="file" class="file-input form-control" formControlName="file" accept=".zip"
              (change)="onFileSelectedZip($event)" multiple>
          </div>
        </form>
        @if (isUploadError) {
          <div class="mb-3">
            <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" [disabled]="!uploadZipRebateForm.valid || isUploading"
          (click)="uploadZipFile()">
          @if (isUploading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
            <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Update File Model -->
<div class="modal" tabindex="-1" id="updateFileModal" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Rebate File</h5>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">File (jpg only)</label>
          <input type="file" class="form-control" accept=".jpg" (change)="onFileSelected($event)">
        </div>
        @if (isError) {
          <div>
            <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="updateFile()" [disabled]="!selectedFile">
          @if (isUploading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
            <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
